import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import { useTicketsSelected, useSaturated } from '@/store';
import TicketSelectedItem from '../tickets/TicketSelectedItem';

function BookingSummary({ changeView = () => {} }) {
  const { t } = useTranslation();
  const { ticketsSelected } = useTicketsSelected();
  const { isEnabled } = useSaturated();

  useEffect(() => {
    if (ticketsSelected.length < 1) {
      changeView('home');
    }
  }, [ticketsSelected]);

  return (
    <>
      {ticketsSelected.length > 0 && (
        <Box
          sx={{
            width: '100%',
            mt: 2,
          }}
        >
          <Typography variant="h5" component="div">
            {t('checkout.home.cart.title')}
          </Typography>
          <Typography
            variant="caption2"
            component="div"
            sx={{ color: (theme) => theme.palette.grey[500] }}
          >
            {t('checkout.home.cart.desc')}
          </Typography>
        </Box>
      )}
      {!ticketsSelected.length && (
        <Box
          sx={{
            width: '100%',
            mt: 2,
          }}
        >
          <Typography
            variant="caption2"
            component="div"
            sx={{ color: (theme) => theme.palette.grey[500] }}
          >
            {t('checkout.home.cart.selectFromMap')}
          </Typography>
        </Box>
      )}

      <Box
        sx={{
          width: '100%',
          mt: 2,
        }}
      >
        {ticketsSelected.map((ticketSelected) => (
          <TicketSelectedItem key={ticketSelected.id} ticket={ticketSelected} />
        ))}
      </Box>
      {!isEnabled && ticketsSelected.length > 0 && (
        <Box
          sx={{
            width: '100%',
            mt: 2,
          }}
        >
          <Typography
            variant="caption2"
            component="div"
            sx={{ color: (theme) => theme.palette.grey[400] }}
          >
            {t('checkout.home.cart.instruction')}
          </Typography>
        </Box>
      )}
    </>
  );
}

export default BookingSummary;
